import { render } from "./GradeForm.vue?vue&type=template&id=9cb7edb6"
import script from "./js/gradeForm.js?vue&type=script&lang=js&external"
export * from "./js/gradeForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__